// data-field: バリデーションの個別設定、以下の要素を自動付与して制御する
// - data-focus: 1度でもfocusしたか, focusしていたらメッセージを表示
// - data-valid: 正値か, 正値でなければ next,submitはできない
// - data-submit: [次へ]と[送信]ボタンをここで制御する

efo()

function efo() {
    // html:type の設定するとf-traが機能しなくなる恐れがある(入力補完もそうだが、数値自体取得できなさそう…)
    const formItemList = {
        'sei': {
            label: '姓',
            html: {
                placeholder: '山田',
            }
        },
        'mei': {
            label: '名',
            html: {
                placeholder: '太郎',
            }
        },
        'sei_kana': {
            label: 'セイ',
            valid: 'kana',
            html: {
                placeholder: 'ヤマダ',
            }
        },
        'mei_kana': {
            label: 'メイ',
            valid: 'kana',
            html: {
                placeholder: 'タロウ',
            }
        },
        'email': {
            label: 'メールアドレス',
            valid: 'email',
            html: {
                // type: 'email',
                placeholder: 'works.taro@litalico.co.jp',
            },
        },
        'tel': {
            label: '電話番号',
            valid: 'tel',
            html: {
                // type: 'tel',
                placeholder: '09012345678',
            },
        },
        'postcode': {
            label: '郵便番号',
            valid: 'address',
            html: {
                placeholder: '1530051',
            },
        },
        'pref': {
            label: '都道府県',
            valid: 'address',
        },
        'city': {
            label: '市区町村',
            valid: 'address',
            html: {
                placeholder: '目黒区上目黒',
            },
        },
    }

    const validateRegxpPattern = {
        'required': {
            pattern: /\S+/,
            message: 'ご入力ください',
        },
        'check': {
            message: '選択してください',
        },
        'kana': {
            pattern: "^[ァ-ヶー]*$",
            message: '全角カタカナでご入力ください'
        },
        'integer': {
            pattern: "^[0-9]*$",
            message: '半角数字・ハイフンなしでご入力ください'
        },
        'email': {
            pattern: /^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}.[A-Za-z0-9]{1,}$/,
            message: 'メールアドレスの形式でご入力ください'
        },
        'tel': {
            pattern: /\d{9,15}/,
            message: '電話番号を半角数字でご入力ください'
        },
        'postcode': {
            pattern: /\d{7,9}/,
            message: '郵便番号を半角数字でご入力ください'
        },
        'pdc': {
            pattern: "%E2%91%A0|%E2%91%A1|%E2%91%A2|%E2%91%A3|%E2%91%A4|%E2%91%A5|%E2%91%A6|%E2%91%A7|%E2%91%A8|%E2%91%A9|%E2%91%AA|%E2%91%AB|%E2%91%AC|%E2%91%AD|%E2%91%AE|%E2%91%AF|%E2%91%B0|%E2%91%B1|%E2%91%B2|%E2%91%B3|%E2%85%A0|%E2%85%A1|%E2%85%A2|%E2%85%A3|%E2%85%A4|%E2%85%A5|%E2%85%A6|%E2%85%A7|%E2%85%A8|%E2%85%A9|%E3%8D%89|%E3%8C%94|%E3%8C%A2|%E3%8D%8D|%E3%8C%98|%E3%8C%A7|%E3%8C%83|%E3%8C%B6|%E3%8D%91|%E3%8D%97|%E3%8C%8D|%E3%8C%A6|%E3%8C%A3|%E3%8C%AB|%E3%8D%8A|%E3%8C%BB|%E3%8E%9C|%E3%8E%9D|%E3%8E%9E|%E3%8E%8E|%E3%8E%8F|%E3%8F%84|%E3%8E%A1|%E3%8D%BB|%E3%80%9D|%E3%80%9F|%E2%84%96|%E3%8F%8D|%E2%84%A1|%E3%8A%A4|%E3%8A%A5|%E3%8A%A6|%E3%8A%A7|%E3%8A%A8|%E3%88%B1|%E3%88%B2|%E3%88%B9|%E3%8D%BE|%E3%8D%BD|%E3%8D%BC",
            message: '機種依存文字は使用できません'
        }
    }

    init()               // 初期設定
    inputActionHandle()  // 入力時の挙動制御
    blockExitWindow()    // 途中離脱防止

    /**
     * 初期設定
     */
    function init() {
        $(window).on('load', function () {
            // 入力項目 =============================
            // 個別設定[誕生日]: selectの設定
            $('[data-field=birthday]').find('select').wrap('<div data-field="required">')
            $('[data-field=birthday]').removeAttr('data-field')

            // 全項目: placeholderを設定、バリデーションチェック
            $('[data-field]').each(function (index, element) {
                // エラーメッセージを設定
                $(element).append('<div class="message"></div>')

                // 入力項目ごとにエラー確認
                const item = $(element).data('field')
                $.each($(element).find(':input'), function (index, input) {
                    checkItemValue(input)  // 正値か確認

                    // 初期設定(placeholderなど)を設定
                    if (formItemList[item] !== undefined && formItemList[item].html !== undefined) {
                        $.each(formItemList[item].html, function (type, val) {
                            $(input).attr(type, val)
                        })
                    }
                })
            })

            // Enterでの送信を防ぐ
            $("input").on("keydown", function (e) {
                if ((e.which && e.which === 13) || (e.keyCode && e.keyCode === 13)) {
                    return false;
                } else {
                    return true;
                }
            })

            // 次へ, 送信ボタン =============================
            checkSubmitButton('next')
        })
    }

    /**
     * 入力時挙動制御
     */
    function inputActionHandle() {
        // 入力後、値が変更されたら
        $(document).on('change', '[data-field] :input', function (e) {
            // 1. 変更した入力項目を確認
            $(e.target).closest('[data-field]').attr('data-focus', true)
            checkItemValue(e.target) //バリデーション&エラーハンドリング

            // 2. f-traの入力補完がある場合、そこも合わせて確認する
            const field = $(e.target).closest('[data-field]').data('field')
            const promiseObj = (function () {
                return new Promise((resolve, reject) => {
                    try {
                        setTimeout(function() {
                            if (field == 'sei' || field == 'mei') {
                                checkItemValue($('[data-field=sei_kana] input'))
                                checkItemValue($('[data-field=mei_kana] input'))
                            } else if (field == 'postcode') {
                                checkItemValue($('[data-field=pref] select'))
                                checkItemValue($('[data-field=city] input'))
                            }
                            resolve()
                        }, 100)
                    } catch (error) {
                        reject('送信ボタン制御エラー')
                    }
                })
            })()
            promiseObj
            .then(function () {
                checkSubmitButton('next') //送信ボタン制御
            })
            .catch(function (error) {
                console.log(error)
            })
        })

        // focusが離れたら
        $(document).on('blur', '[data-field] :input', function (e) {
            $(e.target).closest('[data-field]').attr('data-focus', true)
            checkItemValue(e.target) //バリデーション&エラーハンドリング
        })

        // エラーメッセージclick
        $(document).on('click', '[data-field] .message', function () {
            $(this).closest('[data-field]').attr('data-focus', false)
        })

        // ステップ移動・送信時の処理
        $(document).on('click', '.prev, [data-submit]', function (e) {
            console.log('move')
            // どの操作が行われたのかチェック
            const isSubmit = $('input[type=submit]').is(':visible')
            const btnDirection = $(e.target).hasClass('prev')
            const submitType = isSubmit ? 'submit' : (btnDirection ? 'prev' : 'next')

            // 全項目: バリデーションチェック
            $('[data-field] :input').each(function (index, element) {
                checkItemValue(element)
            })

            // 送信可能で、次へ進むボタンを押していたら、次へ進む
            if (checkSubmitButton(submitType) && submitType === 'next') {
                stepForm.moveNext()
                checkSubmitButton()
            }
        })
    }

    /**
     * 入力値バリデーション
     * @param {*} element 
     * @returns 
     */
    function checkItemValue(element) {
        // 項目が存在しなかったら戻る
        if ($(element).length < 1) return

        // バリデーション設定：項目ごとに個別で指定されていればそちらを適用
        const field = $(element).closest('[data-field]').data('field')
        let validate = field
        if (formItemList[field] !== undefined) {
            validate = formItemList[field].valid !== undefined ? formItemList[field].valid : 'required'
        }

        // 値を再設定：エラーが起こりやすい値を事前にこちらで整形
        let val
        if (validate == 'check') {
            // radio, checkbox
            const inputName = $(element).attr('name')
            const inputVal = $('input[name=' + inputName + ']:checked').val()
            val = inputVal !== undefined ? inputVal : ''

        } else {
            // 1. 前後の空白を除く
            val = $(element).val().trim()
            // 2. 全角=>半角へ置換 (integer, email, telに適用)
            if (validate.match(/integer|email|tel/)) {
                val = val.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function (s) {
                    return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
                }).replace(/＠/g, '@');
            }
            // x. 値を再設定
            $(element).val(val)
        }

        // バリデーション確認
        // 1. 全項目：機種依存文字チェック（例 №,①,㊤ etc）
        if (!validateRegexp(element, encodeURI(val), 'pdc')) {
            return false
        }

        // 2. バリデーション設定項目のチェック
        if (validate !== undefined) {
            // input, select, textなど
            if (validate === 'address') {
                return validateAddress(element, val, field)
            } else if (!validateRegexp(element, val, 'required')) {
                // 必須なのに未記入だったら
                return false
            } else if (validate !== 'check' && !validateRegexp(element, val, validate)) {
                // 個別バリデート
                return false
            }
        }
        return setItemValidateMessage(element, null)
    }

    /**
     * バリデーションメッセージ設定
     * @param {*} element 
     * @param {String} message 
     * @returns 
     */
    function setItemValidateMessage(element, message) {
        const field = $(element).closest('[data-field]')
        const error = field.find('.message')
        const result = message === null

        error.html(message) //文章をセット
        field.attr('data-valid', result)

        if (message) {
            error.addClass('_error')
        } else {
            error.removeClass('_error')
        }
        return result
    }

    /**
     * 住所バリデーション
     * @param {*} element 
     * @param {*} val 
     * @param {String} field 
     */
    function validateAddress(element, val, field) {
        let postcode = $('[data-field="postcode"]')
        let pref = $('[data-field="pref"]')
        let city = $('[data-field="city"]')

        let postcodeVal = filedVal(postcode)
        let prefVal = filedVal(pref)
        let cityVal = filedVal(city)

        // どれか入力されていたらそれ以外の値をセットする
        if (filedVal(postcode) || (filedVal(pref) || filedVal(city))) {
            if (filedVal(postcode)) {
                prefVal = '都道府県'
                cityVal = '市区町村'
            } else {
                postcodeVal = '1111111'
            }
        }

        // すべてバリデートチェック
        validateRegexp(postcode, postcodeVal, 'postcode')
        validateRegexp(pref, prefVal, 'required')
        validateRegexp(city, cityVal, 'required')
    }

    /**
     * 入力値返却
     * @param {*} element 
     * @returns 
     */
    function filedVal(element) {
        return element.find(':input').val()
    }

    /**
     * 正規表現バリデーション
     * @param {*} element 
     * @param {*} val 
     * @param {String} type 
     * @returns bool
     */
    function validateRegexp(element, val, type) {
        // 正規表現に該当した値であるか
        const validate = validateRegxpPattern[type]
        const result = val.match(validate.pattern)
        let isError = false;

        if (type === 'pdc') {
            // 機種依存: 1つ以上ある(!=null)だとエラー
            isError = result !== null
        } else {
            // それ以外: マッチしていない(=null)だとエラー
            isError = result === null
        }

        // エラーが出たらメッセージをセット
        const errorMessage = isError ? validate.message : null;
        setItemValidateMessage(element, errorMessage)

        return !isError  // エラーはfalseで返す
    }

    /**
     * 送信ボタン有効化判定
     * @param {String} type 
     * @returns bool
     */
    function checkSubmitButton(type = 'next') {
        let hasError = false
        // typeが'submit'でefoのエラー表示があればエラーフラグをtrueにする
        $('[data-efo=inputs] > div').each(function (i, element) {
            if (type === 'submit' || i + 1 === stepForm.step.current) {
                if ($(element).find('[data-valid=false]').length > 0) {
                    hasError = true
                    return false
                }
            }
        })
        // エラーフラグがtrueの場合submitボタンを無効化（無効化：false / 有効化：true）
        $('[data-submit]').attr('data-submit', !hasError)

        return !hasError
    }

    /**
     * 離脱防止ポップアップ
     */
    function blockExitWindow() {
        window.onbeforeunload = function (e) {
            return "このページを離れますか？"; // Google Chrome以外
            e.returnValue = "このページを離れますか？"; // Google Chrome
        }

        $(document).on('submit', 'form', function (e) {
            window.onbeforeunload = null;  // 関数を削除
        });
    }
}
